export const isMultiProductBannerEnabledForSlug = (slug: string) => {
  return ['money-market-accounts'].includes(slug);
};
